module.exports = __webpack_public_path__ + "static/media/dowload-mobile-app.63824dff.svg";